var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.81809C11.8531 9.81809 13.3554 7.99342 13.3554 5.74256C13.3554 3.49166 12.8621 1.66699 10 1.66699C7.13786 1.66699 6.64453 3.49166 6.64453 5.74256C6.64453 7.99342 8.14686 9.81809 10 9.81809Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3379 16.1481C16.3385 15.8874 16.3397 16.1105 16.3379 16.1481V16.1481Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3301 15.8764C16.2679 11.9554 15.7558 10.8381 11.8371 10.1309C11.8371 10.1309 11.2855 10.8338 9.99977 10.8338C8.71406 10.8338 8.16235 10.1309 8.16235 10.1309C4.28639 10.8304 3.74316 11.9311 3.67173 15.749C3.66587 16.0608 3.66316 16.0772 3.66211 16.041C3.66235 16.1088 3.66263 16.2342 3.66263 16.453C3.66263 16.453 4.59558 18.3337 9.99977 18.3337C15.4039 18.3337 16.3369 16.453 16.3369 16.453C16.3369 16.3124 16.337 16.2147 16.3372 16.1482C16.3361 16.1706 16.334 16.1272 16.3301 15.8764Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapUser);
export default __webpack_public_path__ + "static/media/map-user.2d3adf8011d7a0eb70004648afea63d1.svg";
export { ForwardRef as ReactComponent };